import { useEffect, useState } from 'react'
import logo from './logo.svg';
import './App.css';
import { useDispatch } from 'react-redux';
import Routes from './ReactRoutes';
import HttpClient from './Services/HttpClient';

function App() {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  let token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      HttpClient.defaults.headers.common["Authorization"] =
        `Bearer ${token}` || "";
    }

    HttpClient.interceptors.request.use(
      function (config) {
        // spinning start to show
        setLoader(true);
        return config;
      },
      function (error) {
        setLoader(false);
        return Promise.reject(error);
      }
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // spinning hide
        setLoader(false);
        return response;
      },
      function (error) {
        setLoader(false);
        return Promise.reject(error);
      }
    );
  }, []);

  return (
    <div>
      {loader && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.3)", // 👈 semi-transparent black
            zIndex: 999999, // above other elements
          }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Routes />
      {/* <Main/> */}
    </div>
  )
}

export default App;
